module.exports = __webpack_public_path__ + "img/i2.967bc21a.png";